import React from "react";
import { Button } from "@mui/material";
// import "./style.scss";
import InputTime from "../InputTime";

const Times = (props) => {
  const {
    scheduleIndex,
    setFieldValue,
    startTimeValues,
    startTimeTouched,
    startTimeErrors,
    endTimeValues,
    endTimeTouched,
    endTimeErrors,
    slot,
  } = props;
  const handleAddTimeSlot = () => {
    setFieldValue(
      `scheduleItems.${scheduleIndex}.startTime`,
      startTimeValues ? [...startTimeValues, ""] : []
    );
    setFieldValue(
      `scheduleItems.${scheduleIndex}.endTime`,
      endTimeValues ? [...endTimeValues, ""] : []
    );
  };

  const handleRemoveTimeSlot = (currIIndex) => {
    const currStartTime =
      (startTimeValues &&
        startTimeValues.filter((time, index) => index !== currIIndex)) ||
      [];

    const currEndTime =
      (endTimeValues &&
        endTimeValues.filter((time, index) => index !== currIIndex)) ||
      [];
    setFieldValue(`scheduleItems.${scheduleIndex}.startTime`, currStartTime);
    setFieldValue(`scheduleItems.${scheduleIndex}.endTime`, currEndTime);
  };
  return (
    <>
      <div>
        {startTimeValues &&
          startTimeValues.length > 0 &&
          startTimeValues.map((time, index) => {
            return (
              <div
                className={` ${
                  startTimeValues && startTimeValues.length > 1
                    ? "formatFlex"
                    : "format-mobile"
                }`}
                key={time + index}
              >
                <div className="format-mobile d-flex align-items-start">
                  <div className=" mt-3">
                    {/* <div className="time">From</div> */}

                    <InputTime
                      id={`scheduleItems.${scheduleIndex}.startTime.${index}`}
                      name={`scheduleItems.${scheduleIndex}.startTime.${index}`}
                      value={startTimeValues && startTimeValues[index]}
                      sx={{
                        width: 60,
                        backgroundColor: "#E0EBFF",
                      }}
                      className="format"
                      format="HH:mm:ss"
                      // disabled={slot.day === 0}
                      helperText={
                        startTimeTouched &&
                        startTimeTouched[index] &&
                        startTimeErrors &&
                        startTimeErrors[index]
                      }
                      onChange={(newValue) => {
                        setFieldValue(
                          `scheduleItems.${scheduleIndex}.startTime.${index}`,
                          newValue
                        );
                      }}
                      textColor={slot.active ? "#000" : "#bbb"}

                    />

                    <p className="form-error">
                      {startTimeTouched &&
                      startTimeTouched[index] &&
                      startTimeErrors &&
                      startTimeErrors[index]
                        ? startTimeErrors[index]
                        : null}
                    </p>
                  </div>

                  <div className=" ps-1 mt-3">
                    {/* <div className="time">To</div> */}
                    <InputTime
                      id={`scheduleItems.${scheduleIndex}.endTime.${index}`}
                      name={`scheduleItems.${scheduleIndex}.endTime.${index}`}
                      value={endTimeValues && endTimeValues[index]}
                      sx={{
                        width: 60,
                        backgroundColor: "#E0EBFF",
                      }}
                      format="HH:mm:ss"
                      // disabled={slot.day === 0}
                      minTime={startTimeValues && startTimeValues[index]}
                      helperText={
                        endTimeTouched &&
                        endTimeTouched[index] &&
                        endTimeErrors &&
                        endTimeErrors[index]
                      }
                      onChange={(newValue) => {
                        setFieldValue(
                          `scheduleItems.${scheduleIndex}.endTime.${index}`,
                          newValue
                        );
                      }}
                      textColor={slot.active ? "#000" : "#bbb"}

                    />

                    <p className="form-error">
                      {endTimeTouched &&
                      endTimeTouched[index] &&
                      endTimeErrors &&
                      endTimeErrors[index]
                        ? endTimeErrors[index]
                        : null}
                    </p>
                  </div>

                  <div className="d-flex flex-wrap pb-1">
                    <div className="ps-1 mt-3">
                      <Button
                        variant="outlined"
                        disabled={
                          slot.day === 0 ||
                          (startTimeValues && startTimeValues.length === 10)
                        }
                        onClick={handleAddTimeSlot}
                      >
                        <img alt="no data" src="../images/Layer_1.svg"/>
                        {/* <span style={{ size: "20px" }}>+</span> */}
                      </Button>
                    </div>
                    {startTimeValues && startTimeValues.length > 1 && (
                      <div className="ps-1 mt-3">
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            handleRemoveTimeSlot(index);
                          }}
                        >
                          <span style={{ size: "10px" }}>X</span>
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default Times;
